import axios, { AxiosResponse } from 'axios';
import { BACKEND_PATHS } from '../config';
import {
  CredentialOfferRequest,
  CredentialOfferResponse,
  TokenResponse,
  UserInfo,
  WalletUser,
} from '../types/callback';

export const authService = {
  async fetchToken(
    code: string,
    accessToken: string | null,
  ): Promise<TokenResponse> {
    const response: AxiosResponse<TokenResponse> = await axios.post(
      BACKEND_PATHS.OAUTH_TOKEN_URL,
      { code },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return response.data;
  },

  async processCredentialOffer(
    credentialOfferRequest: CredentialOfferRequest,
    accessToken: string | null,
  ): Promise<CredentialOfferResponse> {
    const response: AxiosResponse<CredentialOfferResponse> = await axios.post(
      BACKEND_PATHS.CREDENTIAL_OFFER,
      credentialOfferRequest,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return response.data;
  },

  async notifyIssuance(
    userInfo: UserInfo,
    device: string,
    did: string,
    accessToken: string | null,
  ): Promise<void> {
    await axios.post(
      BACKEND_PATHS.ISSUANCE_NOTIFICATION,
      { ...userInfo, dispositiu: device, did },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  },

  async getWalletUser(
    document: string,
    accessToken: string | null,
  ): Promise<WalletUser> {
    const response: AxiosResponse<any> = await axios.get(
      BACKEND_PATHS.WALLET_USER.replace(':document', document),
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return response.data;
  },

  async revokeCredentials(did: string, accessToken: string | null) {
    await axios.put(
      `${BACKEND_PATHS.REVOKE_CREDENTIALS}/${did}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  },
};
